/* eslint-disable react/jsx-no-bind */
import React from 'react';
import ReactFromJSON from 'react-from-json';
import PropTypes from 'prop-types';
import { mapPrismicProp } from './helpers';

const ReactFromPrismic = ({ entry, mapping, mapAdditionalProps }) => (
  <ReactFromJSON
    entry={entry}
    mapProp={prop => mapPrismicProp(prop, mapAdditionalProps)}
    mapping={mapping}
  />
);

ReactFromPrismic.propTypes = {
  entry: PropTypes.object,
  mapping: PropTypes.object,
  mapAdditionalProps: PropTypes.func
};

export default ReactFromPrismic;
